import React, { useEffect } from 'react'

// global components
import Header from 'components/Header'
import Footer from 'components/Footer'
import Whatsapp from 'components/Whatsapp'

function Entrega() {
  useEffect(() => {
    window.scrollTo(0, 0)
    document.title = 'LB STORE - Política de Entrega'
  }, [])

  return (
    <div className='flex min-h-screen w-full flex-col bg-white text-gray-800'>
      <Header />

      <main className='mt-20 flex-grow px-6 py-12 text-[14px] leading-7 md:py-16 md:text-[15px] md:leading-8'>
        <div className='mx-auto w-full max-w-5xl'>
          <header className='mb-10'>
            <h1 className='mb-8 text-4xl font-light tracking-wide text-gray-900 md:text-5xl'>
              Política de Entrega & Rastreamento
            </h1>
            <div className='mt-6 h-[2px] w-24 rounded bg-[#491C47]' />
          </header>

          <section className='mb-12 rounded-lg border border-gray-200 bg-gray-50 p-4 md:p-6'>
            <h2 className='mb-2 text-[22px] font-semibold text-gray-900 md:text-[26px]'>Como rastrear meu pedido?</h2>
            <p className='text-[14px] leading-7 text-gray-700 md:text-[15px] md:leading-8'>
              Assim que seu pedido sair da nossa expedição, você receberá uma mensagem pelo{' '}
              <span className='font-semibold text-[#491C47]'>WhatsApp</span> confirmando o envio. Nessa mensagem
              enviaremos também o <span className='font-semibold text-[#491C47]'>código de rastreio</span>. Com ele você
              poderá acompanhar todas as atualizações diretamente no site dos Correios.
            </p>
          </section>

          <div className='space-y-16'>
            <div className='prose prose-gray prose-base md:prose-lg prose-headings:text-gray-900 max-w-none'>
              <section id='prazo-postagem' className='scroll-mt-24 pb-6'>
                <h2 className='mb-4 text-[22px] font-semibold md:text-[26px]'>Prazo de postagem</h2>
                <p>
                  O prazo para <strong>postagem</strong> do seu pedido é de <strong>até 3 dias úteis</strong> após a
                  aprovação do pagamento podendo ser enviado antes, conforme disponibilidade do nosso centro de
                  distribuição.
                </p>
              </section>

              <section id='metodos-envio' className='scroll-mt-24 pb-6'>
                <h2 className='mb-4 text-[22px] font-semibold md:text-[26px]'>Métodos de envio</h2>
                <p>
                  Todas as encomendas são enviadas via <strong>Correios</strong>. O status pode ser consultado por meio
                  do <strong>código de rastreio</strong> fornecido pelo WhatsApp após a expedição.
                </p>
                <p className='text-[13px] text-gray-600 md:text-sm'>
                  Observação: em campanhas com frete grátis ou promocional, a <strong>LB STORE</strong> poderá
                  selecionar a modalidade de envio mais adequada.
                </p>
              </section>

              <section id='prazo-entrega' className='scroll-mt-24 pb-6'>
                <h2 className='mb-4 text-[22px] font-semibold md:text-[26px]'>Prazo de entrega por região</h2>
                <p>
                  O prazo de <strong>entrega</strong> varia conforme sua região e modalidade escolhida. Você poderá
                  consultar essa informação no ato da compra, ao fornecer seus dados à nossa atendente.
                </p>
              </section>

              <section id='endereco' className='scroll-mt-24 pb-6'>
                <h2 className='mb-4 text-[22px] font-semibold md:text-[26px]'>
                  Endereço, tentativas de entrega e devoluções
                </h2>
                <ul className='list-disc pl-6 leading-7 md:leading-8'>
                  <li>
                    <strong>Endereço correto:</strong> cadastre seus dados com atenção. Informações incorretas podem
                    impedir a entrega. Em caso de devolução por endereço incorreto,{' '}
                    <strong>um novo frete será calculado</strong> e o reenvio ocorrerá após o pagamento do novo frete
                    pelo comprador.
                  </li>
                  <li>
                    <strong>Tentativas de entrega:</strong> os Correios realizam tentativas conforme a modalidade. Se
                    não houver sucesso, o objeto poderá ficar disponível para <strong>retirada na agência</strong> por
                    prazo limitado.
                  </li>
                </ul>
              </section>

              <section id='restricao' className='scroll-mt-24 pb-6'>
                <h2 className='mb-4 text-[22px] font-semibold md:text-[26px]'>Áreas com restrição de entrega</h2>
                <p>
                  Em algumas localidades, os Correios aplicam <strong>restrição de entrega</strong>. Nesses casos, o
                  pedido ficará disponível para retirada na agência mais próxima por{' '}
                  <strong>até 5 dias corridos</strong>. Caso não seja retirado, será{' '}
                  <strong>devolvido ao remetente</strong>. Para novo envio, haverá{' '}
                  <strong>cobrança de novo frete</strong>.
                </p>
              </section>

              <section id='atrasos' className='scroll-mt-24 pb-6'>
                <h2 className='mb-4 text-[22px] font-semibold md:text-[26px]'>Atrasos e força maior</h2>
                <p>
                  Entregas podem sofrer <strong>atrasos</strong> em períodos de alto volume (como datas sazonais), em
                  caso de <strong>greves</strong> dos Correios/transportadoras ou por fatores externos (condições
                  climáticas, acessos restritos, fiscalizações). Nesses casos, acompanharemos junto ao transportador e
                  manteremos você informado(a).
                </p>
              </section>

              <section id='extravio-danos' className='scroll-mt-24 pb-6'>
                <h2 className='mb-4 text-[22px] font-semibold md:text-[26px]'>Extravio, avaria e divergência</h2>
                <ul className='list-disc pl-6 leading-7 md:leading-8'>
                  <li>
                    <strong>Embalagem avariada no recebimento:</strong> recuse a entrega e informe-nos imediatamente,
                    anexando fotos.
                  </li>
                  <li>
                    <strong>Produto danificado ou diferente do pedido:</strong> entre em contato em até{' '}
                    <strong>7 dias corridos</strong> após o recebimento, com fotos e descrição, para que possamos
                    orientar a troca/devolução.
                  </li>
                  <li>
                    <strong>Rastreamento sem atualização/extravio:</strong> se o código não atualizar por período acima
                    do normal para sua região, acione nosso suporte. Abriremos uma{' '}
                    <strong>solicitação junto aos Correios</strong> e informaremos os próximos passos.
                  </li>
                </ul>
              </section>

              <section id='faq' className='scroll-mt-24 pb-6'>
                <h2 className='mb-4 text-[22px] font-semibold md:text-[26px]'>Perguntas frequentes</h2>

                <details className='mb-3 rounded-md border p-4'>
                  <summary className='cursor-pointer text-[15px] font-semibold md:text-[17px]'>
                    Quando começo a contar o prazo de postagem?
                  </summary>
                  <p className='mt-2'>
                    A partir da <strong>aprovação do pagamento</strong> pela operadora/banco.
                  </p>
                </details>

                <details className='mb-3 rounded-md border p-4'>
                  <summary className='cursor-pointer text-[15px] font-semibold md:text-[17px]'>
                    Como recebo meu código de rastreio?
                  </summary>
                  <p className='mt-2'>
                    Enviaremos o código via <strong>WhatsApp</strong> assim que o pedido for postado.
                  </p>
                </details>

                <details className='mb-3 rounded-md border p-4'>
                  <summary className='cursor-pointer text-[15px] font-semibold md:text-[17px]'>
                    Posso alterar o endereço após finalizar a compra?
                  </summary>
                  <p className='mt-2'>
                    Se o pedido ainda não foi postado, tentaremos alterar. Após a postagem, não é possível modificar o
                    endereço.
                  </p>
                </details>

                <details className='mb-3 rounded-md border p-4'>
                  <summary className='cursor-pointer text-[15px] font-semibold md:text-[17px]'>
                    Meu CEP tem restrição de entrega. E agora?
                  </summary>
                  <p className='mt-2'>
                    O objeto ficará disponível na agência indicada no rastreio por até 5 dias corridos. Leve um
                    documento com foto.
                  </p>
                </details>
              </section>

              <section id='contato' className='scroll-mt-24 pb-6'>
                <h2 className='mb-4 text-[22px] font-semibold md:text-[26px]'>Canais de atendimento</h2>
                <p>
                  Precisa de ajuda com sua entrega? Fale com a gente pelo <strong>WhatsApp</strong> (ícone no canto da
                  tela) informando seu número de pedido e o CEP de entrega.
                </p>
              </section>
            </div>
          </div>

          <div className='mt-12 rounded-lg border border-gray-200 bg-gray-50 p-4 text-[13px] leading-6 text-gray-600 md:p-6 md:text-sm md:leading-7'>
            <p>
              Importante: esta política complementa os Termos de Uso e a Política de Troca & Devolução da LB STORE. Em
              caso de divergência entre informações do site e comprovantes oficiais dos Correios, prevalecem os
              registros do transportador.
            </p>
          </div>
        </div>
      </main>

      <Footer />
      <Whatsapp />
    </div>
  )
}

export default Entrega
